import { InjectionToken } from '@angular/core';
import { NPrivacyState } from '@df/core/meta/privacy-state.service';

/**
 * Extend app.config with module properties
 * @see config/df.config.twig.part
 */
declare module '@df/core/df-core.config' {
    interface IDfConfig {
        oneTrust: {
            id: string;
            autoBlock?: string;
            autoBlockEnabled: boolean;
            sdk: string;
            enabled: boolean;
        };
    }
}
declare global {
    interface Window {
        OneTrust?: NOnetrust.IApi;
        OnetrustActiveGroups?: string;
    }
}

export namespace NOnetrust {
    export interface IApi {
        ToggleInfoDisplay(): void;
        Init(): void;
        LoadBanner(): void;
        IsAlertBoxClosedAndValid(): boolean;
    }

    export interface IModuleOptions {
        rules: Record<string, NPrivacyState.Area>;
    }

    export const defaultOptions: IModuleOptions = {
        rules: {
            C0001: NPrivacyState.Area.core,
            C0002: NPrivacyState.Area.performance,
            C0003: NPrivacyState.Area.personalization,
            C0004: NPrivacyState.Area.advertising
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('NDfModuleOnetrust.OPTIONS');
}
